import store from '@/store'
import { DEVICE_ID_HEADER, getDeviceId } from '@/utils/device-id'


export const DEMO_ALLOWED_URLS = [
  ["get", "/demo_user_token/"],
  ["get", "/users/"],
  ["get", "/google-search-locations/"],
  ["get", "/sites/"],
  ["get", "/sites/pages/pageruns/"],
  ["post", "/content-brief/note/all/"],
  ["post", "/checklist/get_all_tasks/"],
  ["get", "/proxies/"],
  ["post", "/fetch-page-run-by-secret-key-or-id/"],
  ["post", "/get-ai-run/"],
  ["post", "/get-checklist-for-extension/"],
];

export const sanitizeRequestUrl = (config) => {
  const rawUrl = config.url || '';
  const baseUrl = config.baseURL || API_URL;
  let pathname;

  try {
    pathname = new URL(rawUrl, baseUrl).pathname;
  } catch {
    pathname = rawUrl.replace(/\?.+/, '');
  }

  return pathname
    .replace(/^\/api(?=\/)/, '')
    .replace(/\d+/g, '')
    .replace(/\/\//g, '/');
}

export const requestIntercepter = (config) => {
  // Browser device id for the new-device login check (core.auth.devices on the backend).
  const deviceId = getDeviceId();
  if (deviceId) {
    if (!config.headers) config.headers = {};
    config.headers[DEVICE_ID_HEADER] = deviceId;
  }
  const sanitizedUrl = sanitizeRequestUrl(config);
  if (store.state.isDemoUser) {
    return DEMO_ALLOWED_URLS.some(
      ([method, url]) => method === config.method && url === sanitizedUrl
    )
    ? config
    : Promise.reject('Request not allowed');
  } else {
    return config
  }
}
